export const useGetCoords = () => {
  return (event, pageRef) => {
    if (!pageRef) {
      return { x: 0, y: 0 }
    }

    const page = pageRef.getBoundingClientRect()
    const unscaledPage = pageRef
    const baseX = event.clientX - page.left
    const baseY = event.clientY - page.top

    const zoomRatio = unscaledPage.clientWidth / page.width

    const x = Math.ceil(baseX * zoomRatio)
    const y = Math.ceil(baseY * zoomRatio)

    return { x, y }
  }
}

export default useGetCoords
